<h2 mat-dialog-title>{{ pageTitle | translatepipe}}</h2>
<mat-dialog-content>
  <div class="form-group">
    <div *ngFor="let question of questions; trackBy: trackByQuestionKey">
      <app-question [question]="question" [form]="pageForm"></app-question>
    </div>
    <mat-slide-toggle
      translate
      *ngIf="TabButton"
      [formControl]="openInNewTabControl"
      color="primary"
      class="toggle-field"
    >
      Open In a New Tab
    </mat-slide-toggle>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button translate mat-stroked-button (click)="onCancel()" class="cancel_button">
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    class="submit-button"
    aria-label="Submit the form"
  >
    {{ submitButtonText | translatepipe}}
  </button>
</mat-dialog-actions>
